import dayjs from "dayjs";

let globalDisplacementDays: number | undefined = undefined;

export const setGlobalDateDisplacement = (displacementDays?: number) => {
    globalDisplacementDays = displacementDays;
};

export const getCurrentDate = () => {
    if (globalDisplacementDays != null) {
        return dayjs().add(globalDisplacementDays, "day").toDate();
    }
    return new Date();
};
